import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { AutomationTypes, AutomationTypesConfig, automationTypesConfig } from '@tokeet-frontend/automations'

@Component({
  selector: 'app-automation-type-select',
  templateUrl: './automation-type-select.component.html',
  styleUrls: ['./automation-type-select.component.scss'],
})
export class AutomationTypeSelectComponent implements OnInit {
  @Input() type: AutomationTypes
  automationTypesConfig = automationTypesConfig

  searchCompare = (t: AutomationTypesConfig, s: string) =>
    String(t.label).toLowerCase().includes(String(s).toLowerCase())

  @Output() typeChange = new EventEmitter<AutomationTypes>()

  constructor() {}

  ngOnInit(): void {}

  changeType(type: AutomationTypes) {
    this.typeChange.emit(type)
  }
}
